import api from '@/api/api'
import { getField, updateField } from 'vuex-map-fields'
import Swal from 'sweetalert2'

export const BOOTSTRAP = 'BOOTSTRAP'
export const SET_STATE = 'SET_STATE'
export const LOAD_BATCH = 'LOAD_BATCH'
export const EDIT_ATENDIMENTO = 'EDIT_ATENDIMENTO'
export const DELETE_ATENDIMENTO = 'DELETE_ATENDIMENTO'
export const HISTORICO_ATENDIMENTO = 'HISTORICO_ATENDIMENTO'
export const RESET_STATE = 'RESET_STATE'
export const NOVA_ATENDIMENTO = 'NOVA_ATENDIMENTO'
export const DADOS_ATENDIMENTO = 'DADOS_ATENDIMENTO'

const getDefaultState = () => {
  return {
    ready: false,
    atendimentos: [],
    atendimento: {},
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  async [BOOTSTRAP] ({ dispatch, commit, state }, { data_inicial, data_final } = { data_inicial: 'from', data_final: 'to' }) {
    commit(SET_STATE, { ready: false })
    await dispatch(LOAD_BATCH, { data_inicial, data_final })
    commit(SET_STATE, { ready: true })
  },
  async [LOAD_BATCH] ({ dispatch, commit }, { data_inicial, data_final } = { data_inicial: 'from', data_final: 'to' }) {
    await api.listEntidade('atendimento/' + data_inicial + '/' + data_final).then(
      atendimentos => {
        commit(SET_STATE, { atendimentos })
      },
    )
  },
  async [DADOS_ATENDIMENTO] ({ dispatch, commit }, id) {
    await api.listEntidade('atendimento/' + id).then(
      atendimento => {
        commit(SET_STATE, { ready: false })
        commit(SET_STATE, { atendimento })
        commit(SET_STATE, { ready: true })
      },
    )
  },
  [EDIT_ATENDIMENTO] ({ dispatch }, atendimento) {
    dispatch('form/atendimento/BOOTSTRAP_PROFILE', { atendimento }, { root: true })
  },

  [NOVA_ATENDIMENTO] ({ dispatch }) {
    dispatch('form/atendimento/BOOTSTRAP_PROFILE', { id: null }, { root: true })
  },
  [HISTORICO_ATENDIMENTO] ({ dispatch }, atendimento) {
    dispatch('atendimentologs/BOOTSTRAP', { id: atendimento.id }, { root: true })
  },
  async [DELETE_ATENDIMENTO] ({ dispatch }, atendimento) {
    Swal.fire({
          title: 'Excluir',
          text: 'Tem certeza que deseja excluir o Atendimento?',
          icon: 'question',
          showCancelButton: true,
          showLoaderOnConfirm: true,
          confirmButtonColor: '#109010',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Excluir',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
          focusConfirm: false,
          preConfirm: () => {
            return api.inativarEntidade('atendimento', atendimento.id).then(
              result => result,
              ({
                error = null,
                message = 'Não foi possivel excluir o Atendimento!',
              }) => {
                Swal.fire({
                  icon: 'error',
                  title: error === null ? 'Ocorreu algum erro!' : 'Erro!',
                  text: message,
                })
              },
            )
          },
        }).then(result => {
          if (result.isConfirmed) {
            Swal.fire({
              title: 'O Atendimento foi excluído com sucesso!',
              icon: 'success',
              showConfirmButton: false,
              timer: 2500,
            })
            dispatch(BOOTSTRAP)
          }
        })
      },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
